import { Industry } from '../types/pathway'

/** Industries each skill module is most often delivered into. */
export const moduleIndustries: Record<string, Industry[]> = {
  'leading-through-change': ['healthcare', 'manufacturing', 'finance', 'other'],
  'communicating-change': ['healthcare', 'finance', 'other'],
  'managing-resistance': ['healthcare', 'manufacturing'],
  'organizational-transformation': ['finance', 'manufacturing', 'other'],
  'active-empathetic-listening': ['healthcare', 'other'],
  'leading-effective-communication': ['finance', 'manufacturing', 'other'],
  'difficult-conversations': ['healthcare', 'finance', 'manufacturing'],
  'feedback-that-lands': ['healthcare', 'manufacturing', 'other'],
  'adapting-leadership-styles': ['healthcare', 'manufacturing', 'finance', 'other'],
  'delegation-empowerment': ['healthcare', 'manufacturing'],
  'coaching-for-performance': ['healthcare', 'finance', 'other'],
  'reading-leading-room': ['finance', 'other'],
  'executive-presence': ['finance', 'other'],
  'high-performing-teams': ['healthcare', 'manufacturing', 'other'],
  'emotional-intelligence': ['healthcare', 'finance', 'other'],
  'stakeholder-management': ['finance', 'manufacturing', 'other'],
  'enhancing-business-outcomes': ['finance', 'manufacturing'],
  'strategic-decision-making': ['finance', 'manufacturing', 'other'],
}
